<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información de la Cuenta">
          <b-form>
            <app-banco
              label="Banco"
              :nombre="bancoNombre"
              :lista="bancosList"
              :valido="bancoValido"
              :msjInvalido="bancoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="bancoActualizado">
            </app-banco>  

            <app-moneda
              label="Moneda"
              :nombre="monedaNombre"
              :lista="monedasList"
              :valido="monedaValida"
              :msjInvalido="monedaInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="monedaActualizada">
            </app-moneda>  

            <b-form-group
              label="Nro. Cuenta"
              label-for="cuentaNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuentaNumero"
                v-model.trim= "$v.cuentaNumero.$model" 
                :state="cuentaNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cuentaNumeroFeedback">
                {{ cuentaNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CBU"
              label-for="cbu"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbu"
                v-model.trim= "$v.cbu.$model" 
                :state="cbuValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuFeedback">
                {{ cbuInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CBU Alias"
              label-for="cbuAlias"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbuAlias"
                v-model.trim= "$v.cbuAlias.$model" 
                :state="cbuAliasValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuAliasFeedback">
                {{ cbuAliasInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
            
            <b-form-group
              label="Inactivo"
              label-for="inactivo"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Banco from '../shared/abmSelect.vue';
import Moneda from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancocuenta/getField',
  mutationType: 'bancocuenta/updateField',
});

const CBU = ((value, vm) => {
  /* Sóo validamos si el banco es argentino */
  if (value == '' || vm.bancoPaisId != 1) {
    return true;
  } else {
    if (!isNaN(parseInt(value))) {
      if ((value.length == 1 && parseInt(value) == 0) || value.length == 22) {
        return true;
      }
    }
  }

  return false;
})

export default {
  name: 'BancoCuentaABM',
  components: {
    appBanco: Banco,
    appMoneda: Moneda,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      noValidar: true,
      bancoValido: null,
      bancoInvalidoMsj: '',
      monedaValida: null,
      monedaInvalidaMsj: '',
      cuentaNumeroValido: null,
      cuentaNumeroInvalidoMsj: '',
      cbuValido: null,
      cbuInvalidoMsj: '',
      cbuAliasValido: null,
      cbuAliasInvalidoMsj: '',

      bancos: [],
      bancosList: [],
      monedas: [],
      monedasList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'banco',
      'bancoNombre',
      'moneda',
      'monedaNombre',
      'cuentaNumero',
      'cbu',
      'cbuAlias',
      'inactivo',

      'bancoPaisId'
    ])
  },  
  created() {
    let bancoCuentaId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        bancoCuentaId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('bancocuenta/inicializar', bancoCuentaId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('bancos/getBancosList')
        .then(() => {
          vm.bancos = this.$store.getters['bancos/bancosList']
          vm.bancosList = this.$store.getters['bancos/bancosSelectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de bancos'));

      this.$store.dispatch('monedas/getList')
        .then(() => {
          vm.monedas = this.$store.getters['monedas/list']
          vm.monedasList = this.$store.getters['monedas/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de monedas'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'cuentaNumero' || validarTodos) {
        if (this.$v.cuentaNumero.$error) {
          this.cuentaNumeroValido = false;
          if (!this.$v.cuentaNumero.maxLength) {
            this.cuentaNumeroInvalidoMsj = 'El número de cuenta solo puede contener hasta 20 caracteres.';
          }      
        } else {
          this.cuentaNumeroValido = null;
          this.cuentaNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'cbu' || validarTodos) {
        if (this.$v.cbu.$error) {
          this.cbuValido = false;
          if (!this.$v.cbu.CBU) {
            this.cbuInvalidoMsj = 'Verifique por favor el CBU ingresado.';
          }      
        } else {
          this.cbuValido = null;
          this.cbuInvalidoMsj = '';
        }
      }

      if (campo == 'cbuAlias' || validarTodos) {
        if (this.$v.cbuAlias.$error) {
          this.cbuAliasValido = false;
          if (!this.$v.cbuAlias.maxLength) {
            this.cbuAliasInvalidoMsj = 'El alias de CBU solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.cbuAliasValido = null;
          this.cbuAliasInvalidoMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let banco = null;
      if (this.bancoNombre) {
        banco = this.getSelected(this.bancos, this.bancoNombre);
      }
      this.$store.dispatch('bancocuenta/setBanco', banco);

      let moneda = null;
      if (this.monedaNombre) {
        moneda = this.getSelected(this.monedas, this.monedaNombre);
      }
      this.$store.dispatch('bancocuenta/setMoneda', moneda);
      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('bancocuenta/save')
          .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      } 
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "BancosCuentas" });
    },
    bancoActualizado(bancoNombre) {
      this.bancoNombre = bancoNombre;
    },
    monedaActualizada(monedaNombre) {
      this.monedaNombre = monedaNombre;
    },
  },
  validations: {
    cuentaNumero: {
      maxLength: maxLength(20)
    },
    cbu: {
      CBU
    },
    cbuAlias: {
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
